import React, {Component} from 'react';
import styled from 'styled-components'
import {Box, Heading, Text} from 'rebass';
import {Content, MobileHeader} from "../../components/Base";
import {PostCard} from "../../components/Cards";
import {Divider} from "reakit";


const PageTitle = styled(Heading)`
font-size: 21px;
font-weight: 700;
color: #263039;
 & > span {
    color: #969a9b;
 }
`;


class NewPostApproval extends Component {

	state = {
		posts: []
	};

	componentDidMount() {
		const { isFaculty} = this.props;
		if (isFaculty) {
			this.listener = this.newRequestListener()
		}
	}



	newRequestListener = () => {
		const {profile} = this.props;
		return this.props.firebase.posts().where('status', '==', 0).where('faculty', 'array-contains', profile.id).onSnapshot(snapshot => {
			let result = [];
			snapshot.docs.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			this.setState({posts: result})
		})
	};

	componentWillUnmount() {
		const {isFaculty} = this.props;

		if (isFaculty) {
			this.listener()
		}
	}

	render() {
		const {posts} = this.state;
		const {profile, isFaculty, school} = this.props;
		let many = posts.length > 1;
		return (
			<Box>
				<Box>
					<MobileHeader>
						<PageTitle pt={2}>Approve Posts</PageTitle>
					</MobileHeader>


					<Content>
						<Box pt={[0, 4]}>
							<Box mb={3}>
								<Text fontSize='21px' fontWeight={700} textAlign={'center'}>
									{posts.length} student post request{many && 's'} {many ? 'are' : 'is'} awaiting approval.
								</Text>
							</Box>
							{/* <MobileBox>
								<Flex flexWrap={'wrap'} flexDirection={'row'}>
									{posts.map(post => (
										<Box key={post.id} width={[1, 1 / 2]}>
											<Box>
												<PostCard post={post} profile={profile} interests={interestList} showStatus/>
											</Box>
											<Box width={[1, 0.95]} pr={1}><Divider zIndex={"-9999"}/></Box>
										</Box>
									))}
								</Flex>
							</MobileBox>

							<DesktopBox>
							<Flex flexWrap={'wrap'} flexDirection={'row'}>
								{posts.map(post => (
									<Box key={post.id} width={[1/2]} px={[0, 3]} py={[3, 0]}>
										<ApprovalCard post={post}  profile={profile} isFaculty={isFaculty}/>
									</Box>
								))}
							</Flex>
							</DesktopBox> */}
							{posts.map(post => (
								<Box key={post.id} width={1}>
									<Box mx={'auto'} width={[0.9, 0.6]}>
										<PostCard post={post} profile={profile} showStatus isFaculty={isFaculty} school={school} />
									</Box>
									<Box width={[1, 0.95]} mx={'auto'}><Divider zIndex={"-9999"} /></Box>
								</Box>
							))}
						</Box>
					</Content>

				</Box>

			</Box>
		);
	}
}

export default NewPostApproval;


